import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';
import {
  DividendPayoutsResponse,
  DividendPayoutStatus,
  DividendPeriodFilter,
  DividendSortOrder,
} from './dividend.types';

type Props = {
  companyId: string;
  period?: DividendPeriodFilter;
  search?: string;
  shareClassId?: string;
  skip?: number;
  sortBy?: string;
  sortOrder?: DividendSortOrder;
  status?: DividendPayoutStatus;
  take?: number;
  year?: number;
};

export const useDividendPayouts = ({
  companyId,
  period,
  search,
  shareClassId,
  skip,
  sortBy,
  sortOrder,
  status,
  take,
  year,
}: Props) => {
  const {
    data: { records = [], count = 0, totalPages = 1 } = {},
    isLoading,
    isFetched,
  } = useAppQuery({
    queryKey: [
      QueryKey.DIVIDEND_PAYOUTS,
      companyId,
      { period, search, shareClassId, skip, sortBy, sortOrder, status, take, year },
    ],
    queryFn: () =>
      ApiService.get<DividendPayoutsResponse>(
        { endpoint: BackendRoute.DIVIDENDS },
        {
          queryParams: {
            period,
            search,
            shareClassId,
            skip,
            sortBy,
            sortOrder,
            status,
            take,
            year,
          },
        },
      ),
  });

  return { count, isFetched, isLoading, records, totalPages };
};
